const MENU_ALLOCATION_STATUS = {
  NOT_ALLOCATED: {
    value: 'NOT_ALLOCATED',
    label: 'Not allocated',
  },
  ALLOCATED_NOT_STARTED: {
    value: 'ALLOCATED_NOT_STARTED',
    label: 'Not started',
  },
  ALLOCATED_IN_PROGRESS: {
    value: 'ALLOCATED_IN_PROGRESS',
    label: 'In progress',
  },
  ALLOCATED_OVERDUE: {
    value: 'ALLOCATED_OVERDUE',
    label: 'Overdue',
  },
  ALLOCATED_COMPLETED: {
    value: 'ALLOCATED_COMPLETED',
    label: 'Completed',
  },
}

export default MENU_ALLOCATION_STATUS
